import { useRef, useState } from "react";
import { useT } from "../i18n/store";
import { useFileLoader } from "../hooks/useFileLoader";
import { Icon } from "./Icon";

export const DropZone = () => {
  const t = useT();
  const { handleFile } = useFileLoader();
  const fileRef = useRef<HTMLInputElement>(null);
  const [drag, setDrag] = useState(false);

  return (
    <div
      className={`dropzone${drag ? " drag" : ""}`}
      onClick={() => fileRef.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDrag(false);
        const f = e.dataTransfer.files?.[0];
        if (f) handleFile(f);
      }}
    >
      <div className="dz-icon"><Icon name="upload" size={22} strokeWidth={1.8} /></div>
      <div className="dz-title">{t("dropzone.title")}</div>
      <div className="dz-sub">
        {t("dropzone.sub")}{" "}
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); fileRef.current?.click(); }}
        >{t("dropzone.browse")}</a>
      </div>
      <input
        ref={fileRef}
        type="file"
        accept=".png,image/png,.pdf,application/pdf"
        hidden
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) handleFile(f);
          e.target.value = "";
        }}
      />
    </div>
  );
};
